import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ColumnFilterState } from '@shared/modules/prime-grid-filters/models/column-filter-state';
import { ColumnFilterDefinition } from '../../models/column-filter-definition';

@Component({
  standalone: false,
  selector: 'gstar-grid-filter',
  templateUrl: './grid-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridFilterComponent {
  filterColumn = input.required<ColumnFilterDefinition>();
  updateFilter = output<ColumnFilterState<unknown>>();

  filterHandler<T>(filter: ColumnFilterState<T>): void {
    this.updateFilter.emit(filter);
  }
}
